import axios from 'axios'

export class FolderService {
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND}`;

    static getALLFolders() {
      const dataURL = `${this.serverURL}/folders`
      // console.log('dataURL.pasta');
      //  console.log(dataURL);
      return axios.get(dataURL)
    }

    static getFolder(folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      // console.log('dataURL');
      // console.log(dataURL);
      return axios.get(dataURL)
    }

    static getFolderUserId(folderId) {
      const dataURL = `${this.serverURL}/folderUser/${folderId}`
      // console.log('dataURL');
      // console.log(dataURL);
      return axios.get(dataURL)
    }

    static createFolder(folder) {
      const dataURL = `${this.serverURL}/folder/`
      // console.log('dataURL.folder');
      // console.log(dataURL,folder);
      return axios.post(dataURL, folder)
    }

    static updateFolder(folder, folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      return axios.put(dataURL, folder)
    }

    static deleteFolder(folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      console.log(dataURL)
      return axios.delete(dataURL)
    }
}
